import StatusLabelReact from 'ui/StatusLabel'
import SpaceReact from 'ui/Space'
import React from 'react'
import roundTo from 'round-to'

export function getStatusLabelReact (status) {
  switch (status) {
    case 'success':
      return React.createElement(StatusLabelReact, {
        status: 'success',
        children: 'Data Flowing'
      })
    case 'success-warning':
      return React.createElement(StatusLabelReact, {
        status: 'warning',
        children: 'Data Flowing'
      })
    case 'success-empty':
      return React.createElement(StatusLabelReact, {
        status: 'success',
        children: 'No Data'
      })
    case 'empty':
      return React.createElement(StatusLabelReact, {
        status: 'warning',
        children: 'No Data'
      })
    case 'warning':
      return React.createElement(StatusLabelReact, {
        status: 'warning',
        children: 'Warning'
      })
    case 'error':
      return React.createElement(StatusLabelReact, {
        status: 'error',
        children: 'Failed'
      })
    case 'pending':
      return React.createElement(StatusLabelReact, {
        status: 'running',
        children: 'Syncing'
      })
    default:
      return React.createElement(StatusLabelReact, {
        status: 'unknown',
        children: 'Unknown'
      })
  }
}

export function addSpaceReact (size) {
  return (acc, item, i, array) => {
    acc.push(item)
    if (i + 1 !== array.length) {
      acc.push(React.createElement(SpaceReact, { value: size }))
    }
    return acc
  }
}

export function abbreviateNumber (value) {
  if (value >= 1000000000) {
    const num = value / 1000000000
    return `${roundTo(num, 1)} B`
  }

  if (value >= 1000000) {
    const num = value / 1000000
    return `${roundTo(num, 1)} M`
  }

  if (value >= 1000) {
    const num = value / 1000
    return `${roundTo(num, 1)} K`
  }

  return value
}



// WEBPACK FOOTER //
// ./lib/utils/index.js